export const NoEarlierVersionExists = Symbol('NoEarlierVersionExists');
